import {
    convertToMilliSeconds,
    dateFormatPresets,
    formatDate,
} from '@thoughtspot/date-format-util';
import { dateFormats } from '@thoughtspot/i18n';
import _ from 'lodash';

export const extractTimeZoneAbbreviation = (userTimeZone: string) => {
    const timeZoneAbbreviation = new Date()
        .toLocaleTimeString('en-us', {
            timeZone: userTimeZone,
            timeZoneName: 'short',
        })
        .split(' ')[2];
    return timeZoneAbbreviation;
};

export const getDateFormat = () => dateFormats[dateFormatPresets.DATE_SHORT];

export function getDateStringFromEpoch(epoch: number | string): string {
    return formatDate(convertToMilliSeconds(epoch), getDateFormat(), true);
}
